import { isSameDay, differenceInHours, startOfDay } from 'date-fns'
import { getPopupKey, popupStorage } from './popupStorage'

export interface CanShowPopupProps {
  popupId: string
  intervalHours: number
  popupDailyLimit: number
  globalDailyLimit: number
  mustShow: boolean
}

/**
 * 檢查各條件下彈窗是否可顯示
 * 1. 檢查今日不再顯示
 * 2. 檢查全站每日觸發上限
 * 3. 檢查單個彈窗每日觸發上限
 * 4. 檢查全站彈窗顯示間隔
 * 5. 針對目標對象，檢查用戶登入狀態
 * 6. 針對目標對象，檢查新舊客人，判斷曾經是否下過單
 * @param CanShowPopupProps
 * @returns
 */
export const canShowPopup = (props: CanShowPopupProps) => {
  const {
    popupId,
    intervalHours,
    popupDailyLimit,
    globalDailyLimit,
    mustShow,
  } = props
  const storage = popupStorage.get()
  const popupKey = getPopupKey(popupId)
  const now = new Date()
  const popupState = storage[popupKey]
  const globalState = storage.global

  // 檢查今日不再顯示
  if (popupState?.suppressUntil) {
    const suppressUntil = new Date(popupState.suppressUntil)
    if (now < suppressUntil) {
      return false
    }
  }

  // 如果是新的一天，重置計數
  if (globalState.lastTriggered) {
    const lastTriggeredDate = new Date(globalState.lastTriggered)
    if (!isSameDay(now, lastTriggeredDate)) {
      popupStorage.set({
        global: {
          triggeredTimes: 0,
        },
      })
      return mustShow
    }
  }

  // 檢查全站每日觸發上限
  if (globalState.triggeredTimes >= globalDailyLimit) {
    return false
  }

  // 檢查單個彈窗每日觸發上限
  if (popupState?.triggeredTimes && popupState.triggeredTimes >= popupDailyLimit) {
    return false
  }

  // 檢查全站彈窗顯示間隔
  if (globalState.lastTriggered) {
    const lastTriggered = new Date(globalState.lastTriggered)
    const now = new Date()
    // 同一天
    if (isSameDay(lastTriggered, now)) {
      const diff = differenceInHours(now, lastTriggered)
      return diff >= intervalHours
    }
    else {
      // 跨夜
      const start = startOfDay(now)
      const diff = differenceInHours(now, start)
      return diff >= intervalHours
    }
  }

  return true
}
